module.exports = __webpack_public_path__ + "img/login-l.bbc3de28.png";